import React, { forwardRef } from 'react';
import { track } from '../modules/tracking';
import PropTypes from 'prop-types';

import { CALORIES_FILTER, HIDE_CALORIES } from '../modules/constants';
import { Toggle } from '.';

/**
 * CaloriesToggle - child filter component which allows filtering of the calorie information.
 *
 * @function
 * @param    {object} props the properties for this filter.
 * @param    {object} ref   Ref forwarded from the parent filter component.
 * @returns  {HTMLElement}  Form allowing to toggle calories.
 * @constructor
 */
const CaloriesToggle = forwardRef(function CalorieToggle(props, ref) {
    const { hideCalories, setHideCalories } = props;

    function collectCaloriesHideData(e) {
        const elem = e.target;
        track(
            `Filters: Click: Hide Calories: ${elem.name} ${elem.checked ? 'filter on' : 'filter off'
            }`
        )();

        setHideCalories(elem.checked);
    }

    return (
        <div className={props.blockClass}>
            <p>{CALORIES_FILTER}</p>
            <form ref={ref} onChange={collectCaloriesHideData.bind(this)}>
                <label className='calorie' htmlFor='calorie'>
                    <input
                        id='calorie'
                        name='hideCalories'
                        type='checkbox'
                        defaultChecked={hideCalories}
                    />
                    <Toggle type='yn' />
                    {HIDE_CALORIES}
                </label>
            </form>
        </div>
    );
});

CaloriesToggle.propTypes = {
    hideCalories: PropTypes.bool,
    setHideCalories: PropTypes.func,
    blockClass: PropTypes.string
};

export { CaloriesToggle };
